// Ids de verrous réservés (non-box) passés au claim générique du channel.
// Le serveur traite toute clé comme un mutex opaque par document ; le préfixe
// 'reserved:' garantit qu'aucun id d'entité (uuid) ne peut entrer en collision.
// Les variables texte utilisent leur clé naturelle 'custom.<id>' (cf.
// variableRefs.js).
export const CONFIGURATOR_LOCK_ID = 'reserved:configurator';
export const SECTION_LOADING_LOCK_ID = 'reserved:section-loading';
// Restauration d'une version du content : le document entier est remplacé →
// verrou global le temps du restore + reload (cf. docs/versioning/07-restore.md).
export const RESTORE_LOCK_ID = 'reserved:restore';

// Verrou d'aperçu de section : pendant qu'un user regarde/génère l'aperçu d'une
// section (plage d'un titre niveau 1), toutes les box de cette section sont
// verrouillées pour les co-éditeurs. La clé encode l'id du container d'ancrage
// (1er container de la plage) → normalisée : deux users sur la MÊME section
// produisent la MÊME clé, donc l'arbitrage atomique serveur tranche les doublons
// (lock_denied). Chaque client dérive la liste des box depuis cet ancrage.
export const PREVIEW_LOCK_PREFIX = 'reserved:preview:';
export const previewLockId = (anchorContainerId) =>
  `${PREVIEW_LOCK_PREFIX}${anchorContainerId}`;
export const parsePreviewLockId = (key) =>
  typeof key === 'string' && key.startsWith(PREVIEW_LOCK_PREFIX)
    ? key.slice(PREVIEW_LOCK_PREFIX.length)
    : null;
